import { atom } from 'recoil';

const localUserEnv = localStorage.getItem('userEnv');

export const userEnvState = atom<Record<string, string>>({
  key: 'UserEnv',
  default: localUserEnv ? JSON.parse(localUserEnv) : {}
});

export const profileState = atom<any>({
  key: 'Profile',
  default: null
});
